import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import "./style.scss"
import SelectDropdown from "../common/selectDropdown";
import {changeCurrentDistrict, fetchDistricts} from "../../actions/districts";
import {clearSchools} from "../../actions/schools";
import {filterUserDistricts, isUserASuperUser} from "../../utils/users";

function SelectDistrict() {
  const currentDistrict = useSelector((state) => state.districts.currentDistrict);
  const compositeUser = useSelector((state) => state.session.currentUserComposite);
  const currentDistrictId = (currentDistrict) ? currentDistrict.id : 0;
  const dispatch = useDispatch();

  useEffect(() => {
      dispatch(fetchDistricts());
      dispatch(clearSchools());
  }, [compositeUser, dispatch]);

  const districts = useSelector((state) => state.districts.districts);

  return (
      <SelectDropdown
        items ={filterUserDistricts(compositeUser, districts)}
        defaultText = 'Select District'
        id = 'district'
        name = 'district'
        label = 'District'
        currentSelectedValue = {currentDistrictId}
        changeAction = {(selectedDistrict) => {if (selectedDistrict !== 0) {dispatch(changeCurrentDistrict(filterUserDistricts(compositeUser, districts).find(element => element.id === selectedDistrict)))}}}
      />
  );
}

export default SelectDistrict;